import CustomAlert from "./CustomAlert";

export default CustomAlert;
